"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlacementDropdownMenuItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _usePlacementFlow = require("./usePlacementFlow");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PlacementDropdownMenuItem = _ref => {
  let {
    option,
    props
  } = _ref;
  const {
    getIconForEntityType /* getNameForEntityType */
  } = (0, _usePlacementFlow.usePlacementFlow)();
  const Icon = getIconForEntityType(option.value);
  return /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MenuItem, _extends({}, props, {
    style: {
      display: "flex",
      alignItems: "center"
    }
    // TODO: use translation after merge of translation PR
    ,
    text: option.label,
    renderLeftComponent: () => /*#__PURE__*/_react.default.createElement(Icon, {
      size: 20,
      style: {
        marginRight: 6
      }
    })
  }));
};
exports.PlacementDropdownMenuItem = PlacementDropdownMenuItem;
//# sourceMappingURL=PlacementDropdownMenuUtils.js.map